import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface SelectFieldClasses {
	/** Styles applied to the root element. */
	root: string;
	multiple: string;
	autocomplete: string;
	selectedIcon: string;
}

export const getSelectFieldUtilityClass = (slot: string) =>
	generateUtilityClass('SelectField', slot);

export const selectFieldClasses = generateUtilityClasses('SelectField', [
	'root',
	'autocomplete',
	'multiple',
	'selectedIcon',
]);
export default selectFieldClasses;
